var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('table',{style:(_vm.style)},[_c('caption',[_vm._v(_vm._s(_vm.caption))]),_vm._v(" "),_c('thead',_vm._l((_vm.firstRow),function(cell,c){return (_vm.dataCol(c))?_c('th',[_vm._v(_vm._s(cell))]):_vm._e()})),_vm._v(" "),_c('tbody',_vm._l((_vm.table),function(row,r){return (r)?_c('tr',_vm._l((row),function(cell,c){return (_vm.dataCol(c))?_c('td',[_vm._v(_vm._s(cell))]):_vm._e()})):_vm._e()}))])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f105438","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Table.vue
// module id = 2785
// module chunks = 1